import React from 'react';
import cn from 'classnames';
import styles from './Loader.module.scss';
import './Loader.scss';

export const Loader: React.FC<{ className?: string }> = ({ className}) => (
  <div className={cn(styles.loader, className)}>
    <div className={`fadeIn ${styles.lds_ripple}`}>
      <div></div>
      <div></div>
    </div>
  </div>
);
